import { HeartIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";

import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { AbsenceTypeId } from "~/modules/absence/api/absence/absenceTypes.ts";
import { sickDayQueries } from "~/modules/absence/api/sickDay/sickDayQueries.ts";
import { useAbsenceActions } from "~/modules/absence/hooks/useAbsenceActions.tsx";
import { AddPillButton } from "~/modules/dashboard/components/AddPillButton.tsx";
import { FigureRow } from "~/modules/dashboard/components/FigureRow.tsx";
import { formatNumberWithComma } from "~/utils/numberUtils.ts";

type Props = {
	staffMemberId: string;
};

// The "+" opens the create sidebar only, so the hook gets no absence lists.
export function SickDayBox({ staffMemberId }: Props) {
	const year = new Date().getFullYear();
	const { data, isPending, isError } = useQuery(sickDayQueries.byYear(staffMemberId, year));
	const { dialogs, openCreate } = useAbsenceActions({ absences: [], absenceTypes: [], staffMemberId });

	return (
		<div>
			<div className="mb-3 flex min-h-7 items-center justify-between gap-2">
				<h3 className="text-lg font-semibold text-gray-900">Krankmeldung</h3>
				<AddPillButton label="Krankmeldung eintragen"
							   onClick={() => openCreate({ absenceTypeId: AbsenceTypeId.Sick })} />
			</div>
			<div className="rounded-lg border border-gray-200 bg-white p-3">
				<p className="mb-3 text-sm text-gray-500">Bei Krankheit melde dich vor Arbeitsbeginn und trage die Abwesenheit ein.</p>
				{isPending && <LoadingSpinner theme="neutral" />}
				{isError && <p className="text-sm text-gray-500">Die Krankheitstage konnten nicht geladen werden.</p>}
				{data && (
					<dl>
						<FigureRow icon={HeartIcon}
								   label="Krankheitstage"
								   value={formatNumberWithComma(data.sickDays, 1, true)} />
					</dl>
				)}
			</div>
			{dialogs}
		</div>
	);
}
